
import state from "./State";
import mutations from "./Mutations";
import actions from "./Actions";
import getters from "./Getters";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
